import React, { Component } from 'react';

//componentes
import FacturaTerapia from './facturaTerapia'

class Index extends Component {

    render(){
        return(
            <div>
                <FacturaTerapia />
            </div>
        );
    }

}
export default Index;